var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-in"},_vm._l((_vm.introductionImgList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":"课程介绍"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }